module.exports = __webpack_public_path__ + "img/4-1.ccea6af4.svg";